import { useRef } from 'react'
import { Button, Col, Row, Tag, Popconfirm, Tooltip, message } from 'antd'
import {
  EyeOutlined,
  DownloadOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons'
import useHook, {
  AnnexItem,
  Props,
  SupplierOrderReceiveInfoItem,
} from './hooks'
import style from './style.module.scss'
import PreviewModal from '../../../../components/previewModal'
import { fileTypeIcon } from '../../../xhNoticeDetail'
import DownloadIcon from '../../../../assets/img/download.png'
import { SignVoucherFileItem } from '../../../../api/orderManage'

export default function OrderInfo(props: Props) {
  const {
    infoObj,
    confirmOrder,
    rejectOrder,
    previewFileUrl,
    isPreviewModalVisible,
    showPreviewModal,
    cancelPreviewModal,
    onDownloadFile,
    downLoadTemplate,
    // 签收凭证
    showUploadBtn,
    uploadBtnText,
    uploading,
    handleUploadFiles,
    handleDeleteVoucher,
    canPreviewFile,
    isRejected,
    isPending,
    isApproved,
    hasVoucherFiles,
    ACCEPT_TYPES,
  } = useHook(props)
  const { productList } = props
  const receiveInfoList = infoObj.receiveInfoList || []
  const contractAmount = Number(infoObj.price)
  const isProtectedContract =
    infoObj.price != null &&
    Number.isFinite(contractAmount) &&
    contractAmount < 200000 &&
    infoObj.orderType !== 'Z040'
  const fileInputRef = useRef<HTMLInputElement>(null)

  return (
    <div className={style['container']}>
      <Row>
        <Col span={4}>
          <div className={style['item-container']}>
            <div className={style['order-title']}>
              <span>采购订单号:{infoObj.code}</span>
            </div>
          </div>
        </Col>
        <Col span={20} style={{ display: 'flex' }}>
          <div
            className={style['item-container']}
            style={{ marginRight: '12px' }}
          >
            <div className={style['item-label']}>
              {infoObj.confirmState &&
              !infoObj.refuseState &&
              productList.every((item) => item.shipQty == 0) ? (
                <Button onClick={confirmOrder}>确认订单</Button>
              ) : null}
            </div>
          </div>
          <div className={style['item-container']}>
            <div className={style['item-label']}>
              {!infoObj.refuseState &&
              infoObj.confirmState &&
              productList.every((item) => item.shipQty == 0) ? (
                <Button onClick={rejectOrder} style={{ color: '#CD3A15' }}>
                  拒绝接单
                </Button>
              ) : null}
              {infoObj.refuseState && (
                <span style={{ color: '#CD3A15' }}>
                  已拒绝，拒绝理由：{infoObj.refuseReason}
                </span>
              )}
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Row>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>创建时间:</div>
                <div className={style['item-content']}>
                  {infoObj.orderCreateTime}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>订单状态:</div>
                <div className={style['item-content']}>
                  {infoObj.scpShipStatusName}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>采购组织:</div>
                <div className={style['item-content']}>
                  {infoObj.purchaseGroupName}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>入库进度:</div>
                <div className={style['item-content']}>
                  {infoObj.warehousingProgress}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>采购员:</div>
                <div className={style['item-content']}>
                  {' '}
                  {infoObj.purchaseMan}{' '}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>是否厂直发:</div>
                <div className={style['item-content']}>
                  {' '}
                  {infoObj.directShipment ? '是' : '否'}{' '}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>订单金额:</div>
                <div className={style['item-content']}>{infoObj.price}</div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>退货/取消金额:</div>
                <div className={style['item-content']}>
                  {infoObj.cancelReturnPrice}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}> 最终结算金额: </div>
                <div className={style['item-content']}>
                  {typeof infoObj.finalPrice === 'number' ? (
                    <span style={{ color: 'green' }}>{infoObj.finalPrice}</span>
                  ) : (
                    '待订单完成后计算'
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <div className={style['item-container']}>
            <div className={style['item-label']}>供应商:</div>
            <div className={style['item-content']}>{infoObj.supplierName}</div>
          </div>
        </Col>
        <Col span={6}>
          <div className={style['item-container']}>
            <div className={style['item-label']}>客户订单号:</div>
            <div className={style['item-content']}>
              {infoObj.customerOrderCode}
            </div>
          </div>
        </Col>
        <Col span={12}>
          <div className={style['item-container']}>
            <div className={style['item-label']}>备注:</div>
            <div className={style['item-content']}>{infoObj.remark}</div>
          </div>
        </Col>
      </Row>
      <Row style={{ marginBottom: '4px' }}>
        <Col span={6}>
          <div style={{ display: 'flex' }}>
            <span style={{ minWidth: '80px' }}>订单附件：</span>
            {infoObj.annexDTOs ? (
              <div className={style['annexDTOs-ul']}>
                {infoObj.annexDTOs.map((item: AnnexItem) => (
                  <div key={item.id} className={style['annexDTOs-li']}>
                    {fileTypeIcon(item.type.toUpperCase())}
                    <span
                      className={style['annexDTOs-item-name']}
                      title={item.name}
                      onClick={() => showPreviewModal(item)}
                    >
                      {item.name}
                    </span>
                    <img
                      className={style['download-icon']}
                      src={DownloadIcon}
                      onClick={() => onDownloadFile(item)}
                    />
                  </div>
                ))}
              </div>
            ) : (
              ''
            )}
          </div>
        </Col>
        <Col span={6}>
          <div className={style['item-container']}>
            <div className={style['item-label']}>采购合同:</div>
            {/* <span style={{ marginLeft: '3px' }}>
              {infoObj?.contractFiles?.length ? (
                <Uploadfiles
                  title="上传"
                  dataSource={infoObj?.contractFiles}
                  maxCount={1}
                  hiddenDownload
                  code="file"
                  disabled
                />
              ) : (
                '-'
              )}
            </span> */}
            <span style={{ marginLeft: '3px' }}>
              <Button
                onClick={() => downLoadTemplate()}
                style={
                  isProtectedContract ? { paddingRight: '30px' } : undefined
                }
              >
                下载合同
                <DownloadOutlined />
                {isProtectedContract && (
                  <Tooltip
                    title="下载带合同章的受保护PDF。"
                    placement="topRight"
                    getPopupContainer={() => document.body}
                  >
                    <QuestionCircleOutlined
                      aria-label="合同下载说明"
                      onClick={(event) => event.stopPropagation()}
                      style={{
                        position: 'absolute',
                        top: '4px',
                        right: '4px',
                        fontSize: '12px',
                        color: '#999',
                        cursor: 'help',
                      }}
                    />
                  </Tooltip>
                )}
              </Button>
            </span>
          </div>
        </Col>
      </Row>
      {receiveInfoList.length ? (
        <div className={style['receive-info-container']}>
          <div className={style['receive-info-header']}>
            <div className={style['receive-info-title']}>收货信息</div>
            {showUploadBtn && (
              <>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept={ACCEPT_TYPES}
                  multiple
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    const files = Array.from(e.target.files || [])
                    const MAX_SIZE = 50 * 1024 * 1024 // 50MB
                    const oversizedFile = files.find(
                      (file) => file.size > MAX_SIZE,
                    )
                    if (oversizedFile) {
                      message.error(
                        `文件"${oversizedFile.name}"超过50MB，请选择更小的文件`,
                      )
                      e.target.value = ''
                      return
                    }
                    if (files.length > 0) {
                      handleUploadFiles(files as any)
                    }
                    // 清空value，允许再次选择相同文件
                    e.target.value = ''
                  }}
                />
                <Button
                  type="primary"
                  loading={uploading}
                  onClick={() => fileInputRef.current?.click()}
                >
                  {uploadBtnText}
                </Button>
              </>
            )}
          </div>
          {/* 签收凭证信息展示 */}
          {hasVoucherFiles && (
            <div className={style['voucher-section']}>
              <div className={style['voucher-meta']}>
                <span className={style['voucher-label']}>签收凭证</span>
                {infoObj.signVoucherTime && (
                  <span className={style['voucher-time']}>
                    {infoObj.signVoucherTime}
                  </span>
                )}
                {isPending && <Tag color="gold">审核中</Tag>}
                {isApproved && <Tag color="green">审核通过</Tag>}
                {isRejected && <Tag color="red">审核驳回</Tag>}
                {isRejected && infoObj.signVoucherRejectReason && (
                  <span className={style['voucher-reject-reason']}>
                    驳回原因：{infoObj.signVoucherRejectReason}
                  </span>
                )}
              </div>
              <div className={style['voucher-file-list']}>
                {infoObj.signVoucherFiles!.map((file: SignVoucherFileItem) => {
                  const ext = file.name?.split('.').pop()?.toUpperCase() || ''
                  return (
                    <div key={file.id} className={style['voucher-file-item']}>
                      {fileTypeIcon(ext)}
                      <span
                        className={style['voucher-file-name']}
                        title={file.name}
                      >
                        {file.name}
                      </span>
                      <div className={style['voucher-file-actions']}>
                        {canPreviewFile(file) && (
                          <Button
                            type="link"
                            size="small"
                            icon={<EyeOutlined />}
                            onClick={() =>
                              showPreviewModal({
                                ...file,
                                baseUrl: file.baseUrl || '',
                              })
                            }
                          >
                            预览
                          </Button>
                        )}
                        <Button
                          type="link"
                          size="small"
                          icon={<DownloadOutlined />}
                          onClick={() =>
                            onDownloadFile({
                              ...file,
                              baseUrl: file.baseUrl || '',
                            })
                          }
                        >
                          下载
                        </Button>
                        {isPending || isApproved ? null : (
                          <Popconfirm
                            title="确定删除该文件吗？"
                            onConfirm={() => handleDeleteVoucher(file.id)}
                            okText="确定"
                            cancelText="取消"
                          >
                            <Button
                              type="link"
                              size="small"
                              danger
                              icon={<DeleteOutlined />}
                            >
                              删除
                            </Button>
                          </Popconfirm>
                        )}
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          )}
          {receiveInfoList.map(
            (item: SupplierOrderReceiveInfoItem, index: number) => (
              <div
                key={item.id || index}
                className={style['receive-info-item']}
              >
                <div className={style['receive-info-card-title']}>
                  收货信息 {index + 1}
                </div>
                <Row gutter={[24, 12]}>
                  <Col span={8}>
                    <div className={style['receive-info-field']}>
                      <span className={style['receive-info-label']}>
                        收件人：
                      </span>
                      <span className={style['receive-info-value']}>
                        {item.receiveMan || '-'}
                      </span>
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className={style['receive-info-field']}>
                      <span className={style['receive-info-label']}>
                        联系方式：
                      </span>
                      <span className={style['receive-info-value']}>
                        {item.receiveMobile || '-'}
                      </span>
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className={style['receive-info-field']}>
                      <span className={style['receive-info-label']}>
                        收货地址：
                      </span>
                      <span className={style['receive-info-value']}>
                        {item.receiveAddress || '-'}
                      </span>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className={style['receive-info-field']}>
                      <span className={style['receive-info-label']}>
                        收货备注：
                      </span>
                      <span className={style['receive-info-value']}>
                        {item.receiveRemark || '-'}
                      </span>
                    </div>
                  </Col>
                </Row>
              </div>
            ),
          )}
        </div>
      ) : null}
      <PreviewModal
        open={isPreviewModalVisible}
        fileUrl={previewFileUrl}
        onCancel={cancelPreviewModal}
      />
    </div>
  )
}
import { useRef } from 'react'
import { Button, Col, Row, Tag, Popconfirm, Tooltip, message } from 'antd'
import {
  EyeOutlined,
  DownloadOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons'
import useHook, {
  AnnexItem,
  Props,
  SupplierOrderReceiveInfoItem,
} from './hooks'
import style from './style.module.scss'
import PreviewModal from '../../../../components/previewModal'
import { fileTypeIcon } from '../../../xhNoticeDetail'
import DownloadIcon from '../../../../assets/img/download.png'
import { SignVoucherFileItem } from '../../../../api/orderManage'

export default function OrderInfo(props: Props) {
  const {
    infoObj,
    confirmOrder,
    rejectOrder,
    previewFileUrl,
    isPreviewModalVisible,
    showPreviewModal,
    cancelPreviewModal,
    onDownloadFile,
    downLoadTemplate,
    // 签收凭证
    showUploadBtn,
    uploadBtnText,
    uploading,
    handleUploadFiles,
    handleDeleteVoucher,
    canPreviewFile,
    isRejected,
    isPending,
    isApproved,
    hasVoucherFiles,
    ACCEPT_TYPES,
  } = useHook(props)
  const { productList } = props
  const receiveInfoList = infoObj.receiveInfoList || []
  const contractAmount = Number(infoObj.price)
  const isProtectedContract =
    infoObj.price != null &&
    Number.isFinite(contractAmount) &&
    contractAmount < 200000 &&
    infoObj.orderType !== 'Z040'
  const fileInputRef = useRef<HTMLInputElement>(null)

  return (
    <div className={style['container']}>
      <Row>
        <Col span={4}>
          <div className={style['item-container']}>
            <div className={style['order-title']}>
              <span>采购订单号:{infoObj.code}</span>
            </div>
          </div>
        </Col>
        <Col span={20} style={{ display: 'flex' }}>
          <div
            className={style['item-container']}
            style={{ marginRight: '12px' }}
          >
            <div className={style['item-label']}>
              {infoObj.confirmState &&
              !infoObj.refuseState &&
              productList.every((item) => item.shipQty == 0) ? (
                <Button onClick={confirmOrder}>确认订单</Button>
              ) : null}
            </div>
          </div>
          <div className={style['item-container']}>
            <div className={style['item-label']}>
              {!infoObj.refuseState &&
              infoObj.confirmState &&
              productList.every((item) => item.shipQty == 0) ? (
                <Button onClick={rejectOrder} style={{ color: '#CD3A15' }}>
                  拒绝接单
                </Button>
              ) : null}
              {infoObj.refuseState && (
                <span style={{ color: '#CD3A15' }}>
                  已拒绝，拒绝理由：{infoObj.refuseReason}
                </span>
              )}
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Row>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>创建时间:</div>
                <div className={style['item-content']}>
                  {infoObj.orderCreateTime}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>订单状态:</div>
                <div className={style['item-content']}>
                  {infoObj.scpShipStatusName}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>采购组织:</div>
                <div className={style['item-content']}>
                  {infoObj.purchaseGroupName}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>入库进度:</div>
                <div className={style['item-content']}>
                  {infoObj.warehousingProgress}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>采购员:</div>
                <div className={style['item-content']}>
                  {' '}
                  {infoObj.purchaseMan}{' '}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>是否厂直发:</div>
                <div className={style['item-content']}>
                  {' '}
                  {infoObj.directShipment ? '是' : '否'}{' '}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>订单金额:</div>
                <div className={style['item-content']}>{infoObj.price}</div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>退货/取消金额:</div>
                <div className={style['item-content']}>
                  {infoObj.cancelReturnPrice}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}> 最终结算金额: </div>
                <div className={style['item-content']}>
                  {typeof infoObj.finalPrice === 'number' ? (
                    <span style={{ color: 'green' }}>{infoObj.finalPrice}</span>
                  ) : (
                    '待订单完成后计算'
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <div className={style['item-container']}>
            <div className={style['item-label']}>供应商:</div>
            <div className={style['item-content']}>{infoObj.supplierName}</div>
          </div>
        </Col>
        <Col span={6}>
          <div className={style['item-container']}>
            <div className={style['item-label']}>客户订单号:</div>
            <div className={style['item-content']}>
              {infoObj.customerOrderCode}
            </div>
          </div>
        </Col>
        <Col span={12}>
          <div className={style['item-container']}>
            <div className={style['item-label']}>备注:</div>
            <div className={style['item-content']}>{infoObj.remark}</div>
          </div>
        </Col>
      </Row>
      <Row style={{ marginBottom: '4px' }}>
        <Col span={6}>
          <div style={{ display: 'flex' }}>
            <span style={{ minWidth: '80px' }}>订单附件：</span>
            {infoObj.annexDTOs ? (
              <div className={style['annexDTOs-ul']}>
                {infoObj.annexDTOs.map((item: AnnexItem) => (
                  <div key={item.id} className={style['annexDTOs-li']}>
                    {fileTypeIcon(item.type.toUpperCase())}
                    <span
                      className={style['annexDTOs-item-name']}
                      title={item.name}
                      onClick={() => showPreviewModal(item)}
                    >
                      {item.name}
                    </span>
                    <img
                      className={style['download-icon']}
                      src={DownloadIcon}
                      onClick={() => onDownloadFile(item)}
                    />
                  </div>
                ))}
              </div>
            ) : (
              ''
            )}
          </div>
        </Col>
        <Col span={6}>
          <div className={style['item-container']}>
            <div className={style['item-label']}>采购合同:</div>
            {/* <span style={{ marginLeft: '3px' }}>
              {infoObj?.contractFiles?.length ? (
                <Uploadfiles
                  title="上传"
                  dataSource={infoObj?.contractFiles}
                  maxCount={1}
                  hiddenDownload
                  code="file"
                  disabled
                />
              ) : (
                '-'
              )}
            </span> */}
            <span style={{ marginLeft: '3px' }}>
              <Button
                onClick={() => downLoadTemplate()}
                style={
                  isProtectedContract ? { paddingRight: '30px' } : undefined
                }
              >
                下载合同
                <DownloadOutlined />
                {isProtectedContract && (
                  <Tooltip
                    title="下载带合同章的受保护PDF。"
                    placement="topRight"
                    getPopupContainer={() => document.body}
                  >
                    <QuestionCircleOutlined
                      aria-label="合同下载说明"
                      onClick={(event) => event.stopPropagation()}
                      style={{
                        position: 'absolute',
                        top: '4px',
                        right: '4px',
                        fontSize: '12px',
                        color: '#999',
                        cursor: 'help',
                      }}
                    />
                  </Tooltip>
                )}
              </Button>
            </span>
          </div>
        </Col>
      </Row>
      {receiveInfoList.length ? (
        <div className={style['receive-info-container']}>
          <div className={style['receive-info-header']}>
            <div className={style['receive-info-title']}>收货信息</div>
            {showUploadBtn && (
              <>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept={ACCEPT_TYPES}
                  multiple
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    const files = Array.from(e.target.files || [])
                    const MAX_SIZE = 50 * 1024 * 1024 // 50MB
                    const oversizedFile = files.find(
                      (file) => file.size > MAX_SIZE,
                    )
                    if (oversizedFile) {
                      message.error(
                        `文件"${oversizedFile.name}"超过50MB，请选择更小的文件`,
                      )
                      e.target.value = ''
                      return
                    }
                    if (files.length > 0) {
                      handleUploadFiles(files as any)
                    }
                    // 清空value，允许再次选择相同文件
                    e.target.value = ''
                  }}
                />
                <Button
                  type="primary"
                  loading={uploading}
                  onClick={() => fileInputRef.current?.click()}
                >
                  {uploadBtnText}
                </Button>
              </>
            )}
          </div>
          {/* 签收凭证信息展示 */}
          {hasVoucherFiles && (
            <div className={style['voucher-section']}>
              <div className={style['voucher-meta']}>
                <span className={style['voucher-label']}>签收凭证</span>
                {infoObj.signVoucherTime && (
                  <span className={style['voucher-time']}>
                    {infoObj.signVoucherTime}
                  </span>
                )}
                {isPending && <Tag color="gold">审核中</Tag>}
                {isApproved && <Tag color="green">审核通过</Tag>}
                {isRejected && <Tag color="red">审核驳回</Tag>}
                {isRejected && infoObj.signVoucherRejectReason && (
                  <span className={style['voucher-reject-reason']}>
                    驳回原因：{infoObj.signVoucherRejectReason}
                  </span>
                )}
              </div>
              <div className={style['voucher-file-list']}>
                {infoObj.signVoucherFiles!.map((file: SignVoucherFileItem) => {
                  const ext = file.name?.split('.').pop()?.toUpperCase() || ''
                  return (
                    <div key={file.id} className={style['voucher-file-item']}>
                      {fileTypeIcon(ext)}
                      <span
                        className={style['voucher-file-name']}
                        title={file.name}
                      >
                        {file.name}
                      </span>
                      <div className={style['voucher-file-actions']}>
                        {canPreviewFile(file) && (
                          <Button
                            type="link"
                            size="small"
                            icon={<EyeOutlined />}
                            onClick={() =>
                              showPreviewModal({
                                ...file,
                                baseUrl: file.baseUrl || '',
                              })
                            }
                          >
                            预览
                          </Button>
                        )}
                        <Button
                          type="link"
                          size="small"
                          icon={<DownloadOutlined />}
                          onClick={() =>
                            onDownloadFile({
                              ...file,
                              baseUrl: file.baseUrl || '',
                            })
                          }
                        >
                          下载
                        </Button>
                        {isPending || isApproved ? null : (
                          <Popconfirm
                            title="确定删除该文件吗？"
                            onConfirm={() => handleDeleteVoucher(file.id)}
                            okText="确定"
                            cancelText="取消"
                          >
                            <Button
                              type="link"
                              size="small"
                              danger
                              icon={<DeleteOutlined />}
                            >
                              删除
                            </Button>
                          </Popconfirm>
                        )}
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          )}
          {receiveInfoList.map(
            (item: SupplierOrderReceiveInfoItem, index: number) => (
              <div
                key={item.id || index}
                className={style['receive-info-item']}
              >
                <div className={style['receive-info-card-title']}>
                  收货信息 {index + 1}
                </div>
                <Row gutter={[24, 12]}>
                  <Col span={8}>
                    <div className={style['receive-info-field']}>
                      <span className={style['receive-info-label']}>
                        收件人：
                      </span>
                      <span className={style['receive-info-value']}>
                        {item.receiveMan || '-'}
                      </span>
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className={style['receive-info-field']}>
                      <span className={style['receive-info-label']}>
                        联系方式：
                      </span>
                      <span className={style['receive-info-value']}>
                        {item.receiveMobile || '-'}
                      </span>
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className={style['receive-info-field']}>
                      <span className={style['receive-info-label']}>
                        收货地址：
                      </span>
                      <span className={style['receive-info-value']}>
                        {item.receiveAddress || '-'}
                      </span>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className={style['receive-info-field']}>
                      <span className={style['receive-info-label']}>
                        收货备注：
                      </span>
                      <span className={style['receive-info-value']}>
                        {item.receiveRemark || '-'}
                      </span>
                    </div>
                  </Col>
                </Row>
              </div>
            ),
          )}
        </div>
      ) : null}
      <PreviewModal
        open={isPreviewModalVisible}
        fileUrl={previewFileUrl}
        onCancel={cancelPreviewModal}
      />
    </div>
  )
}
